import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { faqs } from "../../data/megapack";
import { E } from "../Emoji";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq" className="bg-night" data-id="element-130" data-mp="zp42d7umirww">
      <div className="mx-auto max-w-2xl px-5 pb-14" data-id="element-131" data-mp="uqj4hf2ugkbm">
        <h2 id="faq" className="text-center text-3xl font-black text-white" data-id="element-132" data-mp="ut5a3966cpr7">
          <E data-id="element-133" data-mp="71qcftpcewma">❓ LO QUE MÁS NOS PREGUNTAN</E>
        </h2>
        <ul className="mt-7 divide-y divide-line/30 overflow-hidden rounded-2xl border border-line/50 bg-navy" data-id="element-134" data-mp="22n86bh6sufd">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} data-id="element-135" data-mp="c01nu8vadf6m" data-mpi={i}>
                <h3 data-id="element-136" data-mp="bz00b4x33080">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-black text-white transition-colors duration-150 ease-out hover:bg-navy-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sky" data-id="element-137" data-mp="c2nvs9m39wpd">
                    <span data-id="element-138" data-mp="rq2k1fyju6gd">{f.question}</span>
                    <span className="text-xl leading-none text-bright" aria-hidden="true" data-id="element-139" data-mp="vsgzrr6x8q3f">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-140" data-mp="4344cki972ji">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-141" data-mp="83nyrgbfzs1y">
                      <p className="px-4 pb-4 text-sm text-white/75" data-id="element-142" data-mp="noh8ddnmo49c">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}